"use strict";

var marko_template = module.exports = require("marko/dist/vdom").t(),
    components_registry_browser = require("marko/dist/runtime/components/registry-browser"),
    marko_registerComponent = components_registry_browser.r,
    marko_componentType = marko_registerComponent("/MP.WEB$2.0/src/views/components/Switch/index.marko", function() {
      return module.exports;
    }),
    marko_renderer = require("marko/dist/runtime/components/renderer"),
    marko_defineComponent = require("marko/dist/runtime/components/defineComponent"),
    marko_forOf = require("marko/dist/runtime/helpers/for-of"),
    marko_dynamicTag = require("marko/dist/runtime/helpers/dynamic-tag");

function render(input, out, __component, component, state) {
  var data = input;

  let validCases = []

  marko_forOf(input.case, function(_case, index) {
    if ((_case.is == input.by) || (Array.isArray(_case.is) && _case.is.includes(input.by))) {
      Array.isArray( _case.is ) ? 
              // Array case value: Merge with valid cases
              validCases = [...(new Set([ ...validCases, ..._case.is ]) )]
              // String case value
              : validCases.push( _case.is )

      marko_dynamicTag(out, _case.renderBody, null, null, null, null, __component, "switch-" + index);
    }
  });

  if (input.default && (!validCases.includes(input.by))) {
    marko_dynamicTag(out, input.default.renderBody, null, null, null, null, __component, "0");
  }
}

marko_template._ = marko_renderer(render, {
    d_: true,
    e_: marko_componentType
  });

marko_template.Component = marko_defineComponent({}, marko_template._);
